import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Grid } from '@mantine/core';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import { ECOM_PRODUCT_BUNDLE_TYPE_LIST } from '../../../config/constants';
import AppCard from '../../common/AppCard';
import AppText from '../../common/AppText';
import * as classes from '../../../styles/nestedStyles.module.css';
import { useMediaQueryIndex } from '../../../helpers/hooks';

const BundleTypeSelect = ({ showUseCaseInfoCard, onSelect }) => {
  const { isTabletOrSmaller, isDesktopOrSmaller } = useMediaQueryIndex();

  return (
    <>
      <Grid columns={isTabletOrSmaller ? 1 : isDesktopOrSmaller ? 2 : 3}>
        {ECOM_PRODUCT_BUNDLE_TYPE_LIST.map((option) => (
          <Grid.Col key={option.value} span={1}>
            <AppCard
              className={classes['hover-action-card-outlined']}
              onClick={(e) => onSelect(option.value)}
              radius="md"
              shadow="lg"
              style={{ padding: 0, flex: 1, height: '100%' }}
              withBorder
            >
              <AppStack style={{ gap: 0 }}>
                <AppFlexbox
                  style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 12
                  }}
                >
                  <AppStack>
                    <AppText style={{ fontSize: 16, fontWeight: 500 }}>
                      {option.label}
                    </AppText>
                  </AppStack>
                </AppFlexbox>
                <Divider />

                <AppStack style={{ padding: 12 }}>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    {option.description}
                  </AppText>
                </AppStack>
              </AppStack>
            </AppCard>
          </Grid.Col>
        ))}
      </Grid>
      {showUseCaseInfoCard && <></>}
    </>
  );
};

BundleTypeSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  showUseCaseInfoCard: PropTypes.bool
};

export default BundleTypeSelect;
